import { render, staticRenderFns } from "./DocumentDetailsNewForm.vue?vue&type=template&id=076b0688&"
import script from "./DocumentDetailsNewForm.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailsNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports